export enum LogSorterNumberSequence {
  Sequential,
  SequentialMirrored,
  Alternating,
  AlternatingMirrored,
}
